import z from "zod";

export const BRAND_FORM_SCHEMA = z.object({
  name: z.string().min(1, "Name is required"),
  nameAr: z.string().min(1, "Arabic name is required"),
  image: z
    .string()
    .url("Please enter a valid URL")
    .min(1, "Image URL is required"),
  id: z.string().optional(),
  isActive: z.boolean(),
  isLocal: z.boolean(),
});

export type BrandFormData = z.infer<typeof BRAND_FORM_SCHEMA>;
